module.exports = __webpack_public_path__ + "static/hoophouse-638e71eeef0f51094bca08da14c7c4c2.jpg";